<div class="tt-w-comments-pinboard">
  <tt-masonry-layout v-if="items.length > 0"
                     ref="layout"
                     :breakpointsConfig="pinboardConfig.breakpointsConfig" 
                     :useProgressiveLoading="useProgressiveLoading"
                     @loadMore="fetchData"
                     @doneLoading="doneLoading"
                     :class="'tt-w-comments-pinboard__list'">
      <tt-pinboard-item v-for="(item, index) in items"
                        :item="item" 
                        :tileOrder="index"
                        :key="item.id"
                        :commentMaxLength="pinboardConfig.commentMaxLength"
                        :hoverTitleMaxLength="pinboardConfig.hoverTitleMaxLength"
                        :showReviewStars="pinboardConfig.showReviewStars"
                        :showSocialSharing="true"
                        :titleMaxLength="pinboardConfig.titleMaxLength"
                        :userNameMaxLength="pinboardConfig.userNameMaxLength"></tt-pinboard-item>
  </tt-masonry-layout>
  <div v-if="displayShowMoreWrapper" class="tt-w-comments-pinboard__show-more-wrapper">
    <tt-button v-show="displayShowMoreButton" type="primary" @click="showMore" class="tt-w-comments-pinboard__show-more" v-html="$msg('commentsPinboard.showMore')"></tt-button>
    <div v-show="isLoading" class="tt-o-spinner tt-w-comments-pinboard__loading"></div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/widgets/comments-pinboard/comments-pinboard.html